// extracted by mini-css-extract-plugin
export default {"loader":"ImportExportLicense-module_loader__RHVTz"};